import { put, takeLatest, call } from 'redux-saga/effects';

import { pushWithQuery as push } from 'utils/routing';

import { BASE_URLS } from 'redux/modules/journeys/effects';

import { filterJobs } from 'redux/modules/jobs/effects';

// @effect Action
const openFinishedWithFilter$ = 'finishedJourneys/openFinishedWithFilter$';

// @effect Creators
export const openFinishedWithFilter = (filters) => ({
  type: openFinishedWithFilter$,
  payload: filters,
});

// Workers

function* openFinished({ payload }) {
  yield put(filterJobs(payload, { section: 'FINISHED' }));
  yield call(push, BASE_URLS.finished);
}

// Watchers
export function* watchFinishedJourneys() {
  yield takeLatest(openFinishedWithFilter$, openFinished);
}
